import React from 'react'
import BaseLogo from './base-logo.component'

export const Muvi1000Logo = ({ fontSize }) => (
	<BaseLogo fontSize={fontSize}>
		<div className="name">muvi</div>
		<div className="points light-orange">1000</div>
	</BaseLogo>
)
